export function showloading(txt = '加载···') {
    $("#luckysheet-cell-loading").find("span").text(txt).end().show();
};

export function hideloading() {
    $("#luckysheet-cell-loading").hide();
};